import React from 'react'
import AdminProjectContent from '../../Component/AdminProjectContent/AdminProjectContent'


function AdminProjects() {
  return  <AdminProjectContent />
   
}

export default AdminProjects
